import { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Login from './pages/login/login.js';
import Auth0Callback from './pages/auth0-callback/auth0Callback.js';
import RegistroAlumno from './pages/registro-alumno/registroAlumno.js';
import Registro from './pages/registro/registro.js';
import ProtectedRoute from './pages/protectedRoute/protectedRoute.js';
import PermissionRoute from './pages/protectedRoute/PermissionRoute.js';
import MainLayout from './pages/layout/layout.js';
import AdministracionCategorias from './pages/administracion-categorias/administracionCategorias.js';
import AdministracionCanchas from './pages/administracion-canchas/administracionCanchas.js';
import AdministracionProfesores from './pages/administracion-profesores/administracionProfesores.js';
import AdministracionPlanes from './pages/administracion-planes/administracionPlanes.js';
import AdministracionAlumnos from './pages/administracion-alumnos/administracionAlumnos.js';
import SolicitudesAlumnos from './pages/solicitudes-alumnos/SolicitudesAlumnos.js';
import SolicitudesClaseAlumno from './pages/solicitudes-clase-alumno/solicitudesClaseAlumno.js';
import AgendaCalendario from './pages/agenda-calendario/agendaCalendario.js';
import RegistroPagos from './pages/registro-pagos/registroPagos.js';
import AlumnoPerfil from './pages/alumno-perfil/alumnoPerfil.js';
import AlumnoHistorialPagos from './pages/alumno-historial-pagos/alumnoHistorialPagos.js';
import AlumnoClases from './pages/alumno-clases/alumnoClases.js';
import AlumnoSolicitudClase from './pages/alumno-solicitud-clase/alumnoSolicitudClase.js';
import Dashboard from './pages/dashboard/dashboard.js';
import ConfiguracionBot from './pages/configuracion-bot/configuracionBot.js';
import AsistenciaBot from './pages/asistencia-bot/asistenciaBot.js';
import DashboardClub from './pages/club/dashboard/DashboardClub.js';
import CanchasClub from './pages/club/canchas/canchasClub.js';
import PreciosClub from './pages/club/precios/preciosClub.js';
import TurnosClub from './pages/club/turnos/turnosClub.js';
import JugadoresClub from './pages/club/jugadores/jugadoresClub.js';
import DifusionesClub from './pages/club/difusiones/difusionesClub.js';
import AsistenciaTurnos from './pages/club/asistencia-turnos/asistenciaTurnos.js';
import SeniaClub from './pages/club/senia/seniaClub.js';
import JugadorMisTurnos from './pages/jugador/mis-turnos/JugadorMisTurnos.js';
import JugadorNuevoTurno from './pages/jugador/nuevo-turno/JugadorNuevoTurno.js';
import JugadorMisDatos from './pages/jugador/mis-datos/JugadorMisDatos.js';
import AlumnoMisTurnosCancha from './pages/alumno-mis-turnos-cancha/alumnoMisTurnosCancha.js';
import AlumnoNuevoTurnoCancha from './pages/alumno-nuevo-turno-cancha/alumnoNuevoTurnoCancha.js';
import DatosClub from './pages/datos-club/DatosClub.js';
import DatosAcademia from './pages/datos-academia/DatosAcademia.js';
import Portada from './pages/portada/Portada.js';
import PublicNuevoTurno from './pages/public/nuevo-turno/PublicNuevoTurno.js';
import Articulos from './pages/gestion/articulos/articulos.js';
import Proveedores from './pages/gestion/proveedores/proveedores.js';
import Compras from './pages/gestion/compras/compras.js';
import Ventas from './pages/gestion/ventas/ventas.js';
import Gastos from './pages/gestion/gastos/gastos.js';
import CuentaCorriente from './pages/gestion/cuenta-corriente/cuentaCorriente.js';
import Cobros from './pages/gestion/cobros/cobros.js';
import CajaDiaria from './pages/gestion/caja-diaria/cajaDiaria.js';
import MovimientosStock from './pages/gestion/movimientos-stock/movimientosStock.js';
import CategoriasGestion from './pages/gestion/categorias/categorias.js';
import FormasPago from './pages/gestion/formas-pago/formasPago.js';
import Mesas from './pages/gestion/mesas/mesas.js';
import DashboardGestion from './pages/gestion/dashboard/dashboardGestion.js';
import TurnosCaja from './pages/gestion/turnos-caja/TurnosCaja.js';
import RendicionCaja from './pages/gestion/rendicion-caja/RendicionCaja.js';
import GestionUsuarios from './pages/gestion/usuarios/GestionUsuarios.js';
import GestionRoles from './pages/gestion/roles/GestionRoles.js';
import HomeAdministrador from './pages/home-administrador/homeAdministrador.js';
import { LoginProvider } from './context/loginContext.js';
import { PermissionsProvider } from './context/permissionsContext.js';
import { ModulosProvider } from './context/modulosContext.js';
import { ConfigProvider, theme } from 'antd';
import playmanagerLogo from './assets/PlayManager.png';

// Wrappers para establecer el módulo correcto antes de renderizar
const DashboardClubWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <DashboardClub />;
};

const CanchasClubWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <CanchasClub />;
};

const PreciosClubWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <PreciosClub />;
};

const TurnosClubWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <TurnosClub />;
};

const JugadoresClubWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <JugadoresClub />;
};

const DifusionesClubWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <DifusionesClub />;
};

const AsistenciaTurnosWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <AsistenciaTurnos />;
};

const SeniaClubWrapper = () => {
  useEffect(() => {
    localStorage.setItem('moduloSeleccionado', 'club');
  }, []);
  return <SeniaClub />;
};

// Componente para manejar el callback de Auth0 en la raíz
const Auth0RootHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (code || error) {
      console.log('🔍 Código de Auth0 detectado en raíz, redirigiendo a /auth0-callback');
      navigate(`/auth0-callback?${window.location.search}`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return null;
};

// Raíz: si viene Auth0 (code/error) → callback; si no → Portada
const RootRoute = () => {
  const urlParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  const code = urlParams.get('code');
  const error = urlParams.get('error');
  if (code || error) return <Auth0RootHandler />;
  return <Portada />;
};

function App() {
  const [themeConfig] = useState({
    colorPrimary: '#d8ff3e',
    borderRadius: 10,
    colorBgBase: '#151515',
    colorBgContainer: '#202020',
    colorBgElevated: '#2a2a2a',
    colorText: '#f5f5f5',
    colorTextSecondary: '#b3b3b3',
    colorBorder: '#343434',
    colorBorderSecondary: '#444444',
    Button: {
      colorPrimary: '#d8ff3e',
      algorithm: true,
    },
  });

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: themeConfig.colorPrimary,
          borderRadius: themeConfig.borderRadius,
          colorBgBase: themeConfig.colorBgBase,
          colorBgContainer: themeConfig.colorBgContainer,
          colorBgElevated: themeConfig.colorBgElevated,
          colorText: themeConfig.colorText,
          colorTextSecondary: themeConfig.colorTextSecondary,
          colorBorder: themeConfig.colorBorder,
          colorBorderSecondary: themeConfig.colorBorderSecondary,
          colorLink: '#d8ff3e',
          colorLinkHover: '#e9ff8f',
          colorSuccess: '#7cff4f',
          colorWarning: '#f2c94c',
          colorError: '#ff6b6b',
          fontFamily: '"Montserrat", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        },
        components: {
          Button: {
            colorPrimary: themeConfig.Button?.colorPrimary,
            algorithm: themeConfig.Button?.algorithm,
            primaryColor: '#0e1400',
            colorPrimaryHover: '#e6ff78',
            colorPrimaryActive: '#c3ec2f',
          },
          Card: {
            colorBgContainer: themeConfig.colorBgContainer,
            colorBorderSecondary: themeConfig.colorBorder,
          },
          Table: {
            colorBgContainer: themeConfig.colorBgContainer,
            colorBorderSecondary: themeConfig.colorBorder,
            colorTextHeading: '#f5f8ff',
            colorText: themeConfig.colorText,
          },
          Input: {
            colorBgContainer: themeConfig.colorBgContainer,
            colorBorder: themeConfig.colorBorder,
            colorText: themeConfig.colorText,
            activeBorderColor: themeConfig.colorPrimary,
            hoverBorderColor: '#d8ff3e',
          },
          Select: {
            colorBgContainer: themeConfig.colorBgContainer,
            colorBorder: themeConfig.colorBorder,
            colorText: themeConfig.colorText,
          },
          Modal: {
            colorBgElevated: themeConfig.colorBgElevated,
            colorText: themeConfig.colorText,
          },
          Drawer: {
            colorBgElevated: themeConfig.colorBgElevated,
            colorText: themeConfig.colorText,
          },
          Menu: {
            colorBgContainer: themeConfig.colorBgContainer,
            colorText: themeConfig.colorText,
            colorItemBg: themeConfig.colorBgContainer,
            colorItemText: themeConfig.colorText,
            colorItemTextSelected: '#111111',
            colorItemIconSelected: '#111111',
            colorItemBgSelected: '#d8ff3e',
            // Submenú popup
            subMenuItemBg: themeConfig.colorBgContainer,
            itemBg: themeConfig.colorBgContainer,
            popupBg: themeConfig.colorBgContainer,
            darkSubMenuItemBg: themeConfig.colorBgContainer,
            darkItemBg: themeConfig.colorBgContainer,
            darkPopupBg: themeConfig.colorBgContainer,
            // Hover states
            itemHoverBg: 'rgba(216, 255, 62, 0.08)',
            darkItemHoverBg: 'rgba(216, 255, 62, 0.08)',
            horizontalItemHoverBg: 'rgba(216, 255, 62, 0.08)',
          },
        },
      }}
    >
      <LoginProvider>
        <ModulosProvider>
          <PermissionsProvider>
            <Router>
            <Routes>
            {/* Portada pública; si URL tiene code/error de Auth0 → callback */}
            <Route path="/" element={<RootRoute />} />
            
            {/* Login */}
            <Route path="/login" element={<Login />} />
            
            {/* Compatibilidad: ruta vieja ahora redirige al flujo nuevo público */}
            <Route path="/jugador-acceso" element={<Navigate to="/sacar-turno" replace />} />
            <Route path="/sacar-turno" element={<PublicNuevoTurno />} />
            
            {/* Callback de Auth0 */}
            <Route path="/auth0-callback" element={<Auth0Callback />} />
            
            {/* Registro: elegir Alumno o Jugador y completar formulario */}
            <Route path="/registro" element={<Registro />} />
            {/* Redirección para enlaces antiguos */}
            <Route path="/registro-alumno" element={<Navigate to="/registro" replace />} />
            
            {/* Redirigir pantalla antigua de selección de módulo al nuevo inicio admin */}
            <Route
              path="/seleccion-modulo"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Navigate to="/home-administrador" replace />
                </ProtectedRoute>
              }
            />

            {/* Datos del club (empresa) - común a ambos módulos */}
            <Route
              path="/datos-club"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <DatosClub />
                </ProtectedRoute>
              }
            />
            <Route
              path="/datos-academia"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <DatosAcademia />
                </ProtectedRoute>
              }
            />
            
            {/* Rutas protegidas */}
            <Route
              path="/home-administrador"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <HomeAdministrador />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/home-alumno"
              element={
                <ProtectedRoute allowedRoles={['ALUMNO']}>
                  <MainLayout>
                    <div style={{ 
                      padding: window.innerWidth <= 768 ? '16px' : '20px',
                      minHeight: 'calc(100vh - 64px)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                      <div style={{ textAlign: 'center' }}>
                        <img 
                          src={playmanagerLogo} 
                          alt="playmanager" 
                          style={{ 
                            maxWidth: window.innerWidth <= 768 ? '200px' : '300px', 
                            height: 'auto', 
                            width: '100%',
                          }} 
                        />
                      </div>
                    </div>
                  </MainLayout>
                </ProtectedRoute>
              }
            />
            
            {/* Rutas para alumnos */}
            <Route
              path="/perfil"
              element={
                <ProtectedRoute allowedRoles={['ALUMNO']}>
                  <AlumnoPerfil />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mi-historial-pagos"
              element={
                <ProtectedRoute allowedRoles={['ALUMNO']}>
                  <AlumnoHistorialPagos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mis-clases"
              element={
                <ProtectedRoute allowedRoles={['ALUMNO']}>
                  <AlumnoClases />
                </ProtectedRoute>
              }
            />
            <Route
              path="/solicitud-clase"
              element={
                <ProtectedRoute allowedRoles={['ALUMNO']}>
                  <AlumnoSolicitudClase />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mis-turnos-cancha"
              element={
                <ProtectedRoute allowedRoles={['ALUMNO']}>
                  <AlumnoMisTurnosCancha />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reservar-cancha"
              element={
                <ProtectedRoute allowedRoles={['ALUMNO']}>
                  <AlumnoNuevoTurnoCancha />
                </ProtectedRoute>
              }
            />

            {/* Jugador: Nuevo Turno y Mis Turnos */}
            <Route
              path="/jugador/nuevo-turno"
              element={
                <ProtectedRoute allowedRoles={['JUGADOR']}>
                  <JugadorNuevoTurno />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jugador/mis-turnos"
              element={
                <ProtectedRoute allowedRoles={['JUGADOR']}>
                  <JugadorMisTurnos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jugador/mis-datos"
              element={
                <ProtectedRoute allowedRoles={['JUGADOR']}>
                  <JugadorMisDatos />
                </ProtectedRoute>
              }
            />
            
            {/* Administración de Categorías */}
            <Route
              path="/administracion-categorias"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AdministracionCategorias />
                </ProtectedRoute>
              }
            />
            
            {/* Administración de Canchas */}
            <Route
              path="/administracion-canchas"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AdministracionCanchas />
                </ProtectedRoute>
              }
            />
            
            {/* Administración de Profesores */}
            <Route
              path="/administracion-profesores"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AdministracionProfesores />
                </ProtectedRoute>
              }
            />
            
            {/* Configuración del Bot */}
            <Route
              path="/configuracion-bot"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <ConfiguracionBot />
                </ProtectedRoute>
              }
            />
            <Route
              path="/asistencia-bot"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AsistenciaBot />
                </ProtectedRoute>
              }
            />
            
            {/* Administración de Planes */}
            <Route
              path="/administracion-planes"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AdministracionPlanes />
                </ProtectedRoute>
              }
            />
            
            {/* Administración de Alumnos */}
            <Route
              path="/administracion-alumnos"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AdministracionAlumnos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/solicitudes-alumnos"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <SolicitudesAlumnos />
                </ProtectedRoute>
              }
            />
            
            {/* Agenda / Calendario */}
            <Route
              path="/agenda-calendario"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AgendaCalendario />
                </ProtectedRoute>
              }
            />
            
            {/* Solicitudes de Clase de Alumnos */}
            <Route
              path="/solicitudes-clase-alumno"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <SolicitudesClaseAlumno />
                </ProtectedRoute>
              }
            />
            
            {/* Registro de Pagos */}
            <Route
              path="/registro-pagos"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <RegistroPagos />
                </ProtectedRoute>
              }
            />
            
            {/* Módulo Club / Dashboard y Gestión */}
            <Route
              path="/club/dashboard"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <DashboardClubWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club/canchas"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <CanchasClubWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club/precios"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <PreciosClubWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club/turnos"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <TurnosClubWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club/jugadores"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <JugadoresClubWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club/difusiones"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <DifusionesClubWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club/asistencia-turnos"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <AsistenciaTurnosWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path="/club/senia"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <SeniaClubWrapper />
                </ProtectedRoute>
              }
            />
            
            {/* Módulo de Gestión */}
            <Route
              path="/gestion/dashboard"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <DashboardGestion />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/articulos"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Articulos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/proveedores"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Proveedores />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/compras"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Compras />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/ventas"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Ventas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/gastos"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Gastos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/cuenta-corriente"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <CuentaCorriente />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/cobros"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <Cobros />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/caja-diaria"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <CajaDiaria />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/turnos-caja"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <PermissionRoute module="turnos_caja" action="ver">
                    <TurnosCaja />
                  </PermissionRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/rendicion-caja"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <RendicionCaja />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/usuarios"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <PermissionRoute module="usuarios" action="ver">
                    <GestionUsuarios />
                  </PermissionRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/roles"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <PermissionRoute module="usuarios" action="ver">
                    <GestionRoles />
                  </PermissionRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/movimientos-stock"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <MovimientosStock />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/categorias"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <PermissionRoute module="categorias_articulos" action="ver">
                    <CategoriasGestion />
                  </PermissionRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/formas-pago"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <PermissionRoute module="formas_pago" action="ver">
                    <FormasPago />
                  </PermissionRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gestion/mesas"
              element={
                <ProtectedRoute allowedRoles={['ADMINISTRADOR']}>
                  <PermissionRoute module="mesas" action="ver">
                    <Mesas />
                  </PermissionRoute>
                </ProtectedRoute>
              }
            />
            
            {/* Ruta por defecto - redirigir a portada */}
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
          </PermissionsProvider>
        </ModulosProvider>
      </LoginProvider>
    </ConfigProvider>
  );
}

export default App;

